<template>
  <div class="application">
    <!-- <component :is="$route.path === 'demandResponse' ? demandResponse : businessExpansion"></component> -->
    <router-view></router-view>
  </div>
</template>

<script>
import businessExpansion from './businessExpansion/Index.vue'
import demandResponse from './demandResponse/Index.vue'
export default {
  name: '',
  components: {},
  data() {
    return {
      businessExpansion,
      demandResponse
    }
  }
}
</script>

<style lang='scss' scoped>
.application{

}
</style>
